import { type QueryHookOptions, useQuery } from "@apollo/client";
import { CollectionTypesQuery } from "../graphql/queries";
import type {
  CollectionTypesQueryType,
  CollectionTypesQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useCollectionTypesQuery = (
  options?: QueryHookOptions<
    CollectionTypesQueryType,
    CollectionTypesQueryVariablesType
  >
) => {
  return useQuery<CollectionTypesQueryType, CollectionTypesQueryVariablesType>(
    CollectionTypesQuery,
    options
  );
};
